import script from "./landing-page.vue?vue&type=script&setup=true&lang=js"
export * from "./landing-page.vue?vue&type=script&setup=true&lang=js"

import "./landing-page.vue?vue&type=style&index=0&id=413df41c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413df41c"]])

export default __exports__